import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { Success } from "../schemas/common";
import {
	DeveloperCreditAdjustment,
	GeneratedDataDeletion,
} from "../schemas/developer";
import { Direction } from "../schemas/ledger";

export const adjustDeveloperCredits = defineApi("AdjustDeveloperCredits", {
	args: {
		amount: S.Union([S.String, S.Number]),
		direction: Direction,
		notes: S.optionalKey(S.String),
	},
	response: DeveloperCreditAdjustment,
	request: (data) => ({
		method: "POST",
		path: "/developer/credits",
		body: data,
	}),
});

export const { deleteBillingData, deleteGeneratedData, purgeData } = staticApis(
	{
		deleteBillingData: ["DELETE", "/developer/billing", Success],
		deleteGeneratedData: [
			"DELETE",
			"/developer/generated-data",
			GeneratedDataDeletion,
		],
		purgeData: ["DELETE", "/purge", S.Unknown],
	},
);
